import { useState } from "react";
import { useLanguage } from "../../stores/LanguageStore";
import { useForm } from "react-hook-form";
import { Button, Group, Stack } from "@mantine/core";
import SharingController from "../Sharing/SharingController";
import { getProfile, updateProfile } from "../../api/UserAPI";
import { useProfileStore } from "../../stores/UserStore";
import { filterByCreatedByNull } from "../../functions/utilFunctions";


const FilterListSharing = ({
  filterItem,
  closePopover,
  onFinish,
  pageName,
  index,
}) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const sharingForm = useForm({
    defaultValues: {
      sharing: filterItem["sharing"]?.map((x) => ({
        ...x,
        sharing_targets: x?.sharing_targets?.map((sharing_target) => ({
          ...sharing_target,
          option_name: sharing_target.name,
        })),
      })),
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const sharing = sharingForm
      .getValues()
      .sharing.filter((x) => x.sharing_targets.length > 0)
      .map((share) => ({
        ...share,
        ids_list: share.sharing_targets.map((x) => x.id),
        sharing_targets: share.sharing_targets.map((x) => ({
          ...x,
          name: x.option_name,
        })),
      }));

    setLoading(true);

    getProfile().then((res) => {
      let profile = res.data.user_profile;
      let filterSector = [
        ...filterByCreatedByNull(profile.saved_filters)[pageName],
      ];

      let newFilterSector = filterSector.map((f, i) => {
        if (i === index) {
          return {
            ...f,
            sharing,
          };
        }
        return {
          ...f,
        };
      });

      const newData = {
        saved_filters: {
          ...profile.saved_filters,
          [pageName]: newFilterSector,
        },
      };

      updateProfile(null, newData)
        .then((response) => {
          closePopover?.();
          onFinish?.(sharing);
        })
        .finally(() => setLoading(false));
    });
  };

  return (
    <Stack
      component={"form"}
      onSubmit={handleSubmit}
      gap={"xs"}
      w={600}
      pt={16}
      px={8}
    >
      <SharingController
        form={sharingForm}
        readOnly={false}
        allowResellerCustomers={false}
        disablePermissions
      />

      <Group wrap="nowrap" justify="end" mt="xs">
        <Button
          onClick={closePopover}
          size="sm"
          variant="subtle"
          disabled={loading}
        >
          {lang.components.closer.submit}
        </Button>
        <Button type="submit" loading={loading} size="sm">
          {lang.contact_lists.edit.dialog.submit_button}
        </Button>
      </Group>
    </Stack>
  );
};

export default FilterListSharing;
